module.exports = {"210804001":"红海街道","210804002":"海星街道","210804003":"望海街道","210804004":"海东街道","210804100":"熊岳镇","210804101":"芦屯镇","210804102":"红旗满族镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210804.json
// module id = 512
// module chunks = 0